<template>
  <div>
    <header
      class="bg-white dark:bg-gray-800 flex items-center h-14 shadow-b dark:border-b dark:border-gray-700"
    >
<!--        class="2xl:hidden inline-flex items-center justify-center ml-1 w-12 h-12 rounded-lg focus:ring focus:ring-inset focus:outline-none ring-primary-200 dark:ring-gray-600"-->
      <button
        @click.prevent="toggleMainMenu"
        class="inline-flex items-center justify-center ml-1 w-12 h-12 rounded-lg focus:ring focus:ring-inset focus:outline-none ring-primary-200 dark:ring-gray-600"
        :aria-label="__('Toggle Sidebar')"
        :aria-expanded="mainMenuShown ? 'true' : 'false'"
      >
        <Icon type="menu" />
      </button>

      <div class="hidden lg:w-60 flex-shrink-0 md:flex items-center">
        <Link
          :href="$url('/')"
          class="text-gray-900 hover:text-gray-500 active:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300 dark:active:text-gray-500 h-12 rounded-lg flex items-center ml-2 focus:ring focus:ring-inset focus:outline-none ring-primary-200 dark:ring-gray-600 px-4"
          :aria-label="appName"
        >
          <AppLogo class="h-6" />
        </Link>

        <LicenseWarning />
      </div>

      <div class="flex flex-1 px-4 sm:px-8 lg:px-12">
        <GlobalSearch
          class="relative z-50"
          v-if="globalSearchEnabled"
          dusk="global-search-component"
        />

          <!-- this is the shit that is actually used -->
          <div class="reactive-debug flex flex-wrap gap-1">
              <div class="badge badge-primary hidden sm:block">SM</div>
              <div class="badge badge-primary hidden md:block">MD</div>
              <div class="badge badge-primary hidden lg:block">LG</div>
              <div class="badge badge-primary hidden xl:block">XL</div>
              <div class="badge badge-primary hidden 2xl:block">2XL</div>
              <div class="badge badge-primary hidden 3xl:block">3XL</div>
              <div class="badge badge-primary hidden 4xl:block">4XL</div>
              <div class="badge badge-primary hidden 5xl:block">5XL (WIDE)</div>
              <div class="badge badge-primary hidden 6xl:block">6XL (UHD)</div>
              <div class="badge badge-primary hidden 7xl:block">7XL (SONY)</div>
              <div class="badge badge-primary hidden tall:block">TALL</div>
              <div class="badge badge-primary hidden wide:block">WIDE</div>
              <div class="badge badge-primary hidden portrait:block">PORTRAIT</div>
              <div class="badge badge-primary hidden landscape:block">LANDSCAPE</div>
              <div class="badge badge-primary">{{ windowWidth }} x {{ windowHeight }}</div>
          </div>


        <div class="flex items-center pl-6 ml-auto">
          <ThemeDropdown />
          <NotificationCenter v-if="notificationCenterEnabled" />
          <UserMenu class="hidden md:flex ml-2" />
        </div>
      </div>
    </header>
    <!-- Mobile Sidebar -->
<!--      <div class="2xl:hidden w-60" :class="{ hidden: !mainMenuShown }">-->
    <div class="w-60" :class="{ hidden: !mainMenuShown }">
      <div class="fixed inset-0 flex z-50">
        <div class="fixed inset-0" aria-hidden="true">
          <div
            @click="toggleMainMenu"
            class="absolute inset-0 bg-gray-600 dark:bg-gray-900 opacity-75"
          />
        </div>

        <div
          class="bg-white dark:bg-gray-800 relative flex-1 flex flex-col max-w-xxs w-full"
        >
          <div class="absolute top-0 right-0 -mr-12 pt-2">
            <button
              @click.prevent="toggleMainMenu"
              class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              :aria-label="__('Close Sidebar')"
            >
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div class="px-2 border-b border-gray-100 dark:border-gray-700">
            <Link
              :href="$url('/')"
              class="text-gray-900 hover:text-gray-500 active:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300 dark:active:text-gray-500 h-12 px-2 rounded-lg flex items-center focus:ring focus:ring-inset focus:outline-none"
              :aria-label="appName"
            >
              <AppLogo class="h-6" />
            </Link>
          </div>

          <div class="overflow-x-auto">
            <MainMenu class="mt-3 px-2" />
          </div>

          <div
            class="bg-white dark:bg-gray-800 absolute left-0 bottom-0 right-0 py-1 px-2 md:hidden border-t border-gray-100 dark:border-gray-700"
          >
            <UserMenu :mobile="true" />
          </div>

          <div class="flex-shrink-0 w-14" aria-hidden="true">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LicenseWarning from '@/components/LicenseWarning'

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapMutations(['toggleMainMenu']),

    handleResize() {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    },
  },

  components: { LicenseWarning },

  watch: {
    mainMenuShown(newValue) {
      if (newValue == true) {
        document.body.classList.add('overflow-y-hidden')
        return
      }

      document.body.classList.remove('overflow-y-hidden')
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    document.body.classList.remove('overflow-y-hidden')
  },

  computed: {
    ...mapGetters(['mainMenuShown']),

    globalSearchEnabled() {
      return Nova.config('globalSearchEnabled')
    },

    notificationCenterEnabled() {
      return Nova.config('notificationCenterEnabled')
    },

    appName() {
      return Nova.config('appName')
    },
  },
}
</script>
<style>

.reactive-debug .badge {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition-property: color, background-color, border-color, fill, stroke, opacity, -webkit-text-decoration-color, -webkit-box-shadow, -webkit-transform, -webkit-filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, fill, stroke, opacity, -webkit-text-decoration-color, -webkit-box-shadow, -webkit-transform, -webkit-filter, -webkit-backdrop-filter;
    -o-transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-box-shadow, -webkit-transform, -webkit-filter, -webkit-backdrop-filter;
    -webkit-transition-duration: 200ms;
    -o-transition-duration: 200ms;
    transition-duration: 200ms;
    -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    height: 1.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 0.563rem;
    padding-right: 0.563rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: hsl(var(--n) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--n) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--nc) / var(--tw-text-opacity));
    border-radius: var(--rounded-badge, 1.9rem);
}

.reactive-debug .badge-primary {
    --tw-border-opacity: 1;
    border-color: hsl(var(--p) / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: hsl(var(--p) / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: hsl(var(--pc) / var(--tw-text-opacity));
}
.reactive-debug .badge {
    height: 1.05rem;
    font-size: 0.675rem;
    line-height: 0.95rem;
    padding-left: 0.363rem;
    padding-right: 0.363rem;
}

.reactive-debug.flex {
    display: flex
}

.reactive-debug .hidden {
    display: none;
}

.reactive-debug.flex-wrap {
    flex-wrap: wrap
}

.reactive-debug.gap-1 {
    gap: 0.25rem
}

@media (min-width: 640px) {
    .reactive-debug .sm\:block {
        display: block
    }
}

@media (min-width: 768px) {
    .reactive-debug .md\:block {
        display: block
    }
}

@media (min-width: 1024px) {
    .reactive-debug .lg\:block {
        display: block
    }
}

@media (min-width: 1280px) {
    .reactive-debug .xl\:block {
        display: block
    }
}

@media (min-width: 1536px) {
    .reactive-debug .\32xl\:block {
        display: block
    }
}

@media (min-width: 1920px) {
    .reactive-debug .\33xl\:block {
        display: block
    }
}

@media (min-width: 2560px) {
    .reactive-debug .\34xl\:block {
        display: block
    }
}

@media (min-width: 3440px) {
    .reactive-debug .\35xl\:block {
        display: block
    }
}

@media (min-width: 3840px) {
    .reactive-debug .\36xl\:block {
        display: block
    }
}

@media (min-width: 5120px) {
    .reactive-debug .\37xl\:block {
        display: block
    }
}

@media only screen and (max-height: 960px) and (max-width: 480px) {
    .reactive-debug .tall\:block {
        display: block;
    }
}
@media only screen and (max-height: 480px) and (max-width: 960px) {
    .reactive-debug .wide\:block {
        display: block;
    }
}
@media (orientation: portrait) {
    .reactive-debug .portrait\:block {
        display: block;
    }
}
@media (orientation: landscape) {
    .reactive-debug .landscape\:block {
        display: block;
    }
}


@media (orientation: portrait) {
    .reactive-debug .portrait\:block {
        display: block
    }
}

@media (orientation: landscape) {
    .reactive-debug .landscape\:block {
        display: block
    }
}
</style>
